import React from 'react';
import { useParams } from 'react-router-dom';

import { UpsertLookbookProvider } from '../useUpsertLookbook';
import { UpsertLookbookTemplate } from '../templates';
import { ListingListProvider } from '../useListingList';

export function UpsertLookbookPage() {
  const { id } = useParams();

  return (
    <UpsertLookbookProvider id={id}>
      <ListingListProvider>
        <UpsertLookbookTemplate />
      </ListingListProvider>
    </UpsertLookbookProvider>
  );
}
